import {Component, OnInit} from '@angular/core';
import {SampleChartComponent} from "../../charts/sample-chart/sample-chart.component";
import {SampleService} from "../../../services/sample-service/sample.service";
import {Endpoints} from "../../../customs/endpoints";
import { ClientsService } from '../../../services/client-service/clients.service';
import { RapportService } from '../../../services/rapport-service/rapport.service';

@Component({
    selector: 'app-global-view',
    providers: [SampleService, Endpoints],
    standalone: true,
    imports: [
        SampleChartComponent
    ],
    templateUrl: './global-view.component.html',
    styleUrl: './global-view.component.scss'
})
export class GlobalViewComponent implements OnInit{
    totalSamples : number = 0
    totalClients : number = 0
    totalOt : number = 0
    totalRapport : number = 0

    constructor(private sampleService: SampleService,
        private clientService:ClientsService,
        private rapportService:RapportService
    ) {
    }

    ngOnInit(): void {
        this.getTotalSample()
        this.getTotaLClient()
        this.getTotalOT()
        this.getTotalRapport()
    }

    private getTotalSample(){
        this.sampleService.total()
            .subscribe({
                next : res => this.totalSamples = res
            })
    }

    private getTotalRapport(){
        this.rapportService.total()
            .subscribe({
                next : res => this.totalRapport = res.data
            })
    }


    private getTotaLClient(){
        this.clientService.total()
            .subscribe({
                next : res => this.totalClients = res.data
            })
    }

    private getTotalOT(){
        this.sampleService.getSampleStatusCount().subscribe(statusCount => {
            this.totalOt = statusCount['Avec OT']; 
          });
    }



}
